import { TranslationsContext } from '@telia-common-components/shared';
import * as React from 'react';
import { AnalyticsTrigger, Button, Grid, GridColumn, Notice } from 'telia-front-react';
import { useInternetCalculator } from '../InternetCalculatorProvider';
export const ChangeSegmentNotice = () => {
    const { isSecureNet, openSsoFrame } = useInternetCalculator();
    const { translate } = React.useContext(TranslationsContext);
    const prefix = isSecureNet ? 'secureNetCalculator' : 'internetCalculator';
    return (React.createElement(Notice, { align: "center", type: "attention" },
        React.createElement(Grid, { align: ['between-xs', 'middle-xs'], noWrap: ['sm'] },
            React.createElement(GridColumn, { width: ['xs', 'max-sm'] }, translate(`${prefix}.chooseOtherSegment`)),
            React.createElement(GridColumn, { width: ['xs', 'min-sm'] },
                React.createElement(AnalyticsTrigger, { trigger: { id: `Button - ${prefix}: choose correct segment`, callback: 'onClick' } },
                    React.createElement(Button, { size: "small", text: translate(`${prefix}.chooseOtherSegmentButton`), onClick: openSsoFrame }))))));
};
